var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql, useMutation } from '@apollo/client';
export var ACTIVATE_BENEFIT_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation activateTeamAccountBenefit(\n    $teamAccountId: String!\n    $workBenefit: WorkBenefit!\n  ) {\n    activateTeamAccountBenefit(\n      teamAccountId: $teamAccountId\n      workBenefit: $workBenefit\n    ) {\n      workflowId\n    }\n  }\n"], ["\n  mutation activateTeamAccountBenefit(\n    $teamAccountId: String!\n    $workBenefit: WorkBenefit!\n  ) {\n    activateTeamAccountBenefit(\n      teamAccountId: $teamAccountId\n      workBenefit: $workBenefit\n    ) {\n      workflowId\n    }\n  }\n"])));
export var useActivateTeamAccountBenefitMutation = function (teamAccountId, workBenefit, options) {
    return useMutation(ACTIVATE_BENEFIT_MUTATION, __assign({ variables: {
            teamAccountId: teamAccountId,
            workBenefit: workBenefit,
        }, fetchPolicy: 'network-only' }, options));
};
var templateObject_1;
